/**
 * The definition editor's pickers (`GET .../agent-runs/editor-options`,
 * backend `EditorOptionsResponse`): the project's CI jobs, the agents and
 * their model sets, and the budget bounds.
 */

import { z } from 'zod';

export const CiJobSchema = z.object({
  name: z.string(),
  stage: z.string(),
  reports: z.array(z.string()),
});

export const AgentOptionSchema = z.object({
  name: z.enum(['pi', 'claude-code']),
  available: z.boolean(),
  models: z.array(z.string()),
});

export const EditorOptionsSchema = z.object({
  jobs: z.array(CiJobSchema),
  jobs_truncated: z.boolean(),
  jobs_error: z.string().nullable(),
  agents: z.array(AgentOptionSchema),
  default_agent: z.enum(['pi', 'claude-code']).nullable(),
  budget: z.object({
    minutes_min: z.number().int(),
    minutes_max: z.number().int(),
    tokens_min: z.number().int(),
    tokens_max: z.number().int(),
  }),
});

export type CiJob = z.infer<typeof CiJobSchema>;
export type AgentOption = z.infer<typeof AgentOptionSchema>;
export type EditorOptions = z.infer<typeof EditorOptionsSchema>;
